import { useEffect, useState } from "react";
import { api, API, getToken } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { PartnerLayout } from "../../components/PartnerLayout";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { FileText, Eye } from "@phosphor-icons/react";

const IMG_BASE = API.replace(/\/api$/, "");

export default function PartnerSops() {
  const [rows, setRows] = useState([]);
  const [view, setView] = useState(null);
  useEffect(() => { api.get("/partner/sops").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <PartnerLayout>
      <PageHeader title="Service SOPs" subtitle="Guidelines to follow on your jobs" />
      <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="partner-sops-grid">
        {rows.length === 0 && <p className="text-sm text-muted-foreground">No SOPs available for your services yet.</p>}
        {rows.map((s) => (
          <Card key={s.id} className="rounded-sm p-5 border-border" data-testid={`partner-sop-${s.id}`}>
            <h4 className="font-heading font-semibold">{s.title}</h4>
            <p className="text-xs text-muted-foreground mt-0.5"><span className="uppercase tracking-wide">{s.scope === "category" ? "Category" : "Service"}</span> · {s.target}</p>
            <p className="text-xs text-muted-foreground mt-2">Updated {(s.updated_at || "").slice(0, 10)}</p>
            <div className="flex gap-2 mt-3">
              {s.content && <Button size="sm" variant="outline" className="rounded-sm gap-1.5" onClick={() => setView(s)} data-testid={`partner-sop-view-${s.id}`}><Eye size={14} /> View</Button>}
              {s.has_file && <a href={`${IMG_BASE}${s.file_url}?auth=${getToken()}`} target="_blank" rel="noreferrer"><Button size="sm" className="rounded-sm gap-1.5" data-testid={`partner-sop-download-${s.id}`}><FileText size={14} /> {s.file_name || "Download"}</Button></a>}
            </div>
            {(s.key_steps && s.key_steps.length > 0) && (
              <div className="mt-4 rounded-sm border border-primary/20 bg-primary/5 p-3.5" data-testid={`partner-sop-steps-${s.id}`}>
                <p className="label-caps text-primary mb-2">Key steps to follow</p>
                <ol className="list-decimal list-inside space-y-1.5 text-sm text-foreground">
                  {s.key_steps.map((step, i) => <li key={i}>{step}</li>)}
                </ol>
              </div>
            )}
          </Card>
        ))}
      </div>

      {view && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setView(null)} data-testid="partner-sop-modal">
          <div className="bg-card w-full max-w-lg rounded-sm max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="px-5 py-4 border-b border-border flex items-center justify-between">
              <h3 className="font-heading font-semibold">{view.title}</h3>
              <button onClick={() => setView(null)} className="text-muted-foreground">✕</button>
            </div>
            <div className="p-5 prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: view.content }} />
          </div>
        </div>
      )}
    </PartnerLayout>
  );
}
